import layout from '@/layout'

export default {
  path: '/winner',
  component: layout,
  redirect: '/winner/self',
  name: 'winner_self',
  meta: {
    title: 'winner',
    icon: 'winner',
    hidden: true
  },
  children: [
    {
      path: '/winner/self',
      name: 'winner_self',
      component: () => import('@/views/winner/pages/winner_self/index.vue'),
      meta: {
        title: 'winner_self',
        icon: 'bang',
        hidden: true
      }
    }
  ]
}
